import { put } from 'redux-saga/effects';

import { InsighttNotification } from '../../helpers/insightt-notification';
import StatsCompanyActions from '../actions/stats-company.actions';

export function* getActivityLevelRequest(api, action) {
  const { branchId, roleId, startDate, endDate, timezoneOffset } = action;
  const response = yield api.getActivityLevel(branchId, roleId, startDate, endDate, timezoneOffset);
  if (response && response.ok) {
    yield put(StatsCompanyActions.getActivityLevelSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get users activity level', response);
    yield put(StatsCompanyActions.getActivityLevelFailure());
  }
}

export function* getInfractionsRequest(api, action) {
  const { branchId, roleId, startDate, endDate, timezoneOffset } = action;
  const response = yield api.getInfractions(branchId, roleId, startDate, endDate, timezoneOffset);
  if (response && response.ok) {
    yield put(StatsCompanyActions.getInfractionsSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get users infractions', response);
    yield put(StatsCompanyActions.getInfractionsFailure());
  }
}

export function* getUserInfractionsRequest(api, action) {
  const { userId, startDate, endDate, timezoneOffset, currentPage, pageSize, search } = action;
  const response = yield api.getUserInfractions(
    userId,
    startDate,
    endDate,
    timezoneOffset,
    currentPage,
    pageSize,
    search,
  );
  if (response && response.ok) {
    yield put(StatsCompanyActions.getUserInfractionsSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get user infractions', response);
    yield put(StatsCompanyActions.getUserInfractionsFailure());
  }
}

export function* getTotalMissedRepossessionsRequest(api, action) {
  const { branchId, startDate, endDate, timezoneOffset } = action;
  const response = yield api.getTotalMissedRepossessions(branchId, startDate, endDate, timezoneOffset);
  if (response && response.ok) {
    yield put(StatsCompanyActions.getTotalMissedRepossessionsSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get total missed repossessions', response);
    yield put(StatsCompanyActions.getTotalMissedRepossessionsFailure());
  }
}

export function* getMissedRepossessionsRequest(api, action) {
  const { branchId, startDate, endDate, timezoneOffset, currentPage, pageSize, search } = action;
  const response = yield api.getMissedRepossessions(
    branchId,
    startDate,
    endDate,
    timezoneOffset,
    currentPage,
    pageSize,
    search,
  );
  if (response && response.ok) {
    yield put(StatsCompanyActions.getMissedRepossessionsSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get missed repossessions', response);
    yield put(StatsCompanyActions.getMissedRepossessionsFailure());
  }
}

export function* getTotalSpottedVehiclesRequest(api, action) {
  const { branchId, startDate, endDate, timezoneOffset } = action;
  const response = yield api.getTotalSpottedVehicles(branchId, startDate, endDate, timezoneOffset);
  if (response && response.ok) {
    yield put(StatsCompanyActions.getTotalSpottedVehiclesSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get total spotted vehicles', response);
    yield put(StatsCompanyActions.getTotalSpottedVehiclesFailure());
  }
}

export function* getSpottedVehiclesRequest(api, action) {
  const { branchId, startDate, endDate, timezoneOffset, currentPage, pageSize, search } = action;
  const response = yield api.getSpottedVehicles(
    branchId,
    startDate,
    endDate,
    timezoneOffset,
    currentPage,
    pageSize,
    search,
  );
  if (response && response.ok) {
    yield put(StatsCompanyActions.getSpottedVehiclesSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get spotted vehicles', response);
    yield put(StatsCompanyActions.getSpottedVehiclesFailure());
  }
}

export function* getTotalRepossessionsRequest(api, action) {
  const { branchId, startDate, endDate, timezoneOffset } = action;
  const response = yield api.getTotalRepossessions(branchId, startDate, endDate, timezoneOffset);
  if (response && response.ok) {
    yield put(StatsCompanyActions.getTotalRepossessionsSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get total repossessions', response);
    yield put(StatsCompanyActions.getTotalRepossessionsFailure());
  }
}

export function* getRepossessionsRequest(api, action) {
  const { branchId, startDate, endDate, timezoneOffset, currentPage, pageSize, search } = action;
  const response = yield api.getRepossessions(
    branchId,
    startDate,
    endDate,
    timezoneOffset,
    currentPage,
    pageSize,
    search,
  );
  if (response && response.ok) {
    yield put(StatsCompanyActions.getRepossessionsSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get repossessions', response);
    yield put(StatsCompanyActions.getRepossessionsFailure());
  }
}

export function* getHoursWorkedRequest(api, action) {
  const { branchId, startDate, endDate, timezoneOffset } = action;
  const response = yield api.getHoursWorked(branchId, startDate, endDate, timezoneOffset);
  if (response && response.ok) {
    yield put(StatsCompanyActions.getHoursWorkedSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get shift hours worked', response);
    yield put(StatsCompanyActions.getHoursWorkedFailure());
  }
}

export function* getTotalCommissionsRequest(api, action) {
  const { branchId, startDate, endDate, timezoneOffset } = action;
  const response = yield api.getTotalCommissions(branchId, startDate, endDate, timezoneOffset);
  if (response && response.ok) {
    yield put(StatsCompanyActions.getTotalCommissionsSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get total commissions', response);
    yield put(StatsCompanyActions.getTotalCommissionsFailure());
  }
}

export function* getCommissionsRequest(api, action) {
  const { branchId, commissionType, startDate, endDate, timezoneOffset, currentPage, pageSize, search } = action;
  const response = yield api.getCommissions(
    branchId,
    commissionType,
    startDate,
    endDate,
    timezoneOffset,
    currentPage,
    pageSize,
    search,
  );
  if (response && response.ok) {
    yield put(StatsCompanyActions.getCommissionsSuccess(commissionType, response.data));
  } else {
    InsighttNotification('error', 'Unable to get commissions', response);
    yield put(StatsCompanyActions.getCommissionsFailure(commissionType));
  }
}
